'use client'

import { useFeatureFlagsStatus, useIfEnabled, useLaunchDarkly } from '@/providers/LaunchDarkly'

export const ADDRESS_AUTOCOMPLETE_FLAG_KEY = 'address-autocomplete'

export function useAddressAutocompleteEnabled(): boolean {
  const isEnabled = useIfEnabled(ADDRESS_AUTOCOMPLETE_FLAG_KEY)
  const { hasFetched } = useLaunchDarkly()
  const { error } = useFeatureFlagsStatus()

  if (!hasFetched || error) {
    return false
  }

  return isEnabled
}
